module.exports = __webpack_public_path__ + "img/layout_free_tree_icon.e583a5ed.svg";